<template>
  <div>
    <section class="banner-cursos parallax-window" :data-image-src="require('@/assets/img/bannercursos.jpg')">
      <div class="container text-center">
        <h1>{{ $t('cursos') }}</h1>
      </div>
    </section>
    <section class="cursos container">
      <div class="row">
        <div class="col-12 col-md-4 mb-3">
          <div class="box-categorias">
            <div class="nav flex-column nav-pills" id="categorias-cursos-tab">
              <h3><i class="fas fa-sitemap"></i> {{ $t('categorias') }}</h3>
              <a v-for="(categoria, categoriaIndex) in categorias" class="nav-link" :class="[`cat${categoriaIndex + 1}`, categoria.visivel ? 'active': '']" href="javascript:void(0)" @click="exibirCategoria(categoria.id)">{{ categoria.title }}</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <div class="box-cursos">
            <div class="tab-content" id="v-pills-tabContent">
              <div v-for="(categoria, categoriaIndex) in categorias" class="tab-pane fade" :class="[`cat${categoriaIndex+1}`, categoria.visivel ? 'active show': '']" :id="`cat${categoriaIndex+1}`" role="tabpanel">
                <div class="d-flex align-items-center mb-4">
                  <h2>{{ categoria.title }}</h2>
                  <span class="barra-tit-curso flex-fill" :class="`cat${categoriaIndex+1}`"></span>
                </div>
                <div class="row">
                  <div class="col-12 col-md" v-if="categoria.sistemas && categoria.sistemas.length">
                    <h3>{{ $t('sistemas') }}</h3>
                    <auto-complete
                      v-model="termoPesquisaCursoEmSistemas"
                      inputClass="busca-disc"
                      placeholder="Busque pelo curso nos sistemas"
                      :serializer="curso => curso.title"
                      @hit="selecionarCurso($event)"
                      :data="cursosSistemas"
                    />
                    <div v-for="(sistema, sistemaIndex) in categoria.sistemas" class="btn-disc" :class="`cat${categoriaIndex+1}`">
                      <b-link v-b-toggle="`col-cat-${categoriaIndex}-sist-${sistemaIndex}`">
                        {{sistema.title}}
                      </b-link>
                      <b-collapse :visible="sistema.visivel" :id="`col-cat-${categoriaIndex}-sist-${sistemaIndex}`">
                        <h4><i class="fas fa-list-ul"></i> {{ $t('cursos') }}</h4>
                        <ul>
                          <li v-for="curso in sistema.cursos"><a @click="$router.push(urlCurso(curso.url))" href="javascript:void(0)">{{curso.title}}</a></li>
                        </ul>
                      </b-collapse>
                    </div>
                  </div>
                  <div class="col-12 col-md" v-if="categoria.disciplinas && categoria.disciplinas.length">
                    <h3>{{ $t('disciplinas') }}</h3>
                    <auto-complete
                      v-model="termoPesquisaCursoEmDisciplinas"
                      inputClass="busca-disc"
                      placeholder="Busque pelo curso nas disciplinas"
                      :serializer="curso => curso.title"
                      @hit="selecionarCurso($event)"
                      :data="cursosDisciplinas"
                    />
                    <div :class="{ row : !categoria.sistemas }">
                      <div :class="{ 'col-12 col-md-6' : !categoria.sistemas }" v-for="coluna in obterQuantidadeColunas(categoria)">
                        <div v-for="(disciplina, disciplinaIndex) in categoria.disciplinas" :class="`coluna-${coluna}`">
                          <div class="btn-disc" :class="`cat${categoriaIndex + 1}`" v-if="categoria.sistemas || (disciplinaIndex + coluna) % 2 !== 0">
                            <b-link v-b-toggle="`col-cat-${categoriaIndex}-disc-${disciplinaIndex}`">
                              {{ disciplina.title }}
                            </b-link>
                            <b-collapse :visible="disciplina.visivel" :id="`col-cat-${categoriaIndex}-disc-${disciplinaIndex}`">
                              <h4><i class="fas fa-list-ul"></i> {{ $t('cursos') }}</h4>
                              <ul>
                                <li v-for="curso in disciplina.cursos"><a @click="$router.push(urlCurso(curso.url))" href="javascript:void(0)">{{curso.title}}</a></li>
                              </ul>
                            </b-collapse>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import 'jquery-parallax.js'
import CategoriasAPI from '@/api/categorias-api'
import AutoComplete from '@/core/components/autocomplete/AutoComplete'
import Constants from '@/core/constants/constants'

export default {
  name: 'CursosApp',

  components: { AutoComplete },

  data () {
    return {
      termoPesquisaCursoEmSistemas: '',
      termoPesquisaCursoEmDisciplinas: '',
      categorias: [],
      cursosSistemas: [],
      cursosDisciplinas: []
    }
  },

  watch: {
    '$store.getters.exibicaoCursosCategoria': async function () {
      this.exibirCategoria(this.$store.getters.exibicaoCursosCategoria.id)
    }
  },

  created () {
    this.montaParallax()
  },

  beforeDestroy () {
    $('.parallax-mirror').remove()
  },

  mounted () {
    const loader = this.$loading.show()

    let categoriaId
    let categoriaReferencia

    let disciplinaId
    let sistemaId

    if (this.$route.name === 'curso-id-categoria') {
      categoriaId = parseInt(this.$route.params.id)
    } else if (this.$route.name === 'curso-id-disciplina') {
      disciplinaId = parseInt(this.$route.params.id)
    } else if (this.$route.name === 'curso-id-sistema') {
      sistemaId = parseInt(this.$route.params.id)
    } else if (this.$route.name === 'categoria') {
      categoriaReferencia = this.$route.params.referencia
    }

    CategoriasAPI.listarCategorias().then(data => {
      const categorias = data.categorias.sort((cat1, cat2) => cat1.id - cat2.id)
      categorias.forEach((c, index) => {
        if (categoriaId) {
          c.visivel = c.id === categoriaId
        } else if (categoriaReferencia) {
          c.visivel = c.url === categoriaReferencia
        } else {
          c.visivel = index === 0
        }
      })

      if (!categorias.filter(c => c.visivel).length) {
        categorias[0].visivel = 1
      }

      return categorias
    }).then(categorias => {
      CategoriasAPI.listarSistemas().then(data => {
        if (data && data.categorias) {
          data.categorias.map(c => {
            if (c.id === Constants.ID_CATEGORIA_CICLO_BASICO) {
              const categoria = categorias.find(value => value.id === c.id)
              if (categoria) {
                categoria.sistemas = c.sistemas
              }
            }
          })

          if (sistemaId) {
            categorias.forEach(cat => {
              cat.visivel = false
              if (cat.sistemas) {
                const sistemaSelecionado = cat.sistemas.find(sist => sist.id === sistemaId)
                if (sistemaSelecionado) {
                  cat.visivel = true
                  sistemaSelecionado.visivel = true
                }
              }
            })
          }

          this.preencherAutoCompleteCursosSistemas(categorias.find(cat => cat.visivel))
        }

        return categorias
      }).then(categorias => {
        CategoriasAPI.listarDisciplinas().then(data => {
          data.categorias.map(c => {
            const categoria = categorias.find(value => value.id === c.id)
            if (categoria) {
              categoria.disciplinas = c.disciplinas
            }
          })

          if (disciplinaId) {
            categorias.forEach(cat => {
              cat.visivel = false

              if (cat.disciplinas) {
                const disciplinaSelecionada = cat.disciplinas.find(disc => disc.id === disciplinaId)
                if (disciplinaSelecionada) {
                  cat.visivel = true
                  disciplinaSelecionada.visivel = true
                }
              }
            })
          }

          this.preencherAutoCompleteCursosDisciplinas(categorias.find(cat => cat.visivel))

          return categorias
        }).then(categorias => {
          this.categorias = categorias.filter(cat => cat.disciplinas || cat.sistemas)
          this.montaParallax()
          loader.hide()
        })
      })
    })
  },

  methods: {
    montaParallax: function () {
      setTimeout(function () {
        $('.parallax-window').parallax({ imageSrc: require('@/assets/img/bannercursos.jpg') })
      }, 100)
    },

    scrollTo: function ($element) {
      $element && $element.scrollIntoView({ block: 'start', behavior: 'smooth' })
    },

    obterQuantidadeColunas: function (categoria) {
      return categoria.sistemas ? 1 : 2
    },

    urlCurso: function (url) {
      return `/cursos/detalhe/${url}`
    },

    exibirCategoria: function (id) {
      this.categorias.forEach(cat => {
        cat.visivel = cat.id === id
        if (cat.visivel) {
          this.preencherAutoComplete(cat)
        }
      })
      if (window.innerWidth < 768) {
        this.$nextTick(() => {
          this.scrollTo(this.$el.querySelector('#cat' + id))
        })
      }
    },

    preencherAutoComplete: function (categoria) {
      this.preencherAutoCompleteCursosSistemas(categoria)
      this.preencherAutoCompleteCursosDisciplinas(categoria)
    },

    preencherAutoCompleteCursosSistemas: function (categoria) {
      if (categoria && categoria.sistemas && categoria.sistemas.length) {
        this.cursosSistemas = categoria.sistemas.flatMap(sistemas => sistemas.cursos)
      }
    },

    preencherAutoCompleteCursosDisciplinas: function (categoria) {
      if (categoria && categoria.disciplinas && categoria.disciplinas.length) {
        this.cursosDisciplinas = categoria.disciplinas.flatMap(sistemas => sistemas.cursos)
      }
    },

    selecionarCurso: function (curso) {
      window.location = this.urlCurso(curso.url)
    }
  }
}
</script>

<style scoped>

</style>
